import { render, staticRenderFns } from "./currentfightsbanner.vue?vue&type=template&id=d91f7220&"
import script from "./currentfightsbanner.vue?vue&type=script&lang=js&"
export * from "./currentfightsbanner.vue?vue&type=script&lang=js&"
import style0 from "./currentfightsbanner.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VParallax,VRow})
